import React from 'react';

import { CmMessageCard } from '@/components/uiParts';

export const SalesErrorCard: React.FC = () => {
  return (
    <CmMessageCard margin="0 auto">
      集計データがありませんでした。
    </CmMessageCard>
  );
};
